import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisaLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 16",
	width: 24,
	height: 16,
	"aria-hidden": "true",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Visa Icon" }),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_66_2091)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M21.9985 0.25H2.55627C1.45497 0.25 0.562195 1.14543 0.562195 2.25V13.75C0.562195 14.8546 1.45497 15.75 2.55627 15.75H21.9985C23.0998 15.75 23.9926 14.8546 23.9926 13.75V2.25C23.9926 1.14543 23.0998 0.25 21.9985 0.25Z",
				fill: "white",
				stroke: "black",
				strokeOpacity: .2,
				strokeWidth: .5
			}), /* @__PURE__ */ _jsx("path", {
				d: "M3.09243 5.91444C2.57084 5.62751 1.97556 5.39674 1.31 5.23659L1.33792 5.11188H4.06679C4.43667 5.12489 4.73681 5.23651 4.83447 5.63071L5.42753 8.46659L5.60921 9.32073L7.27026 5.11188H9.06375L6.39776 11.2775H4.60418L3.09243 5.91444ZM10.383 11.2841H8.68691L9.74778 5.11188H11.4438L10.383 11.2841ZM16.5316 5.26277L16.3009 6.59559L16.1475 6.53004C15.8406 6.40525 15.4354 6.28054 14.8841 6.29371C14.2144 6.29371 13.9141 6.56277 13.9071 6.82546C13.9071 7.11441 14.2704 7.30484 14.8636 7.58725C15.8409 8.02719 16.2941 8.56557 16.2873 9.26819C16.2736 10.5486 15.115 11.3761 13.3353 11.3761C12.5744 11.3694 11.8415 11.2181 11.4437 11.0476L11.681 9.66205L11.9044 9.76066C12.4558 9.99071 12.8186 10.089 13.4958 10.089C13.9841 10.089 14.5077 9.89838 14.5144 9.48488C14.5144 9.21565 14.2913 9.01851 13.6351 8.71646C12.9931 8.42087 12.1347 7.92848 12.1486 7.04198C12.1558 5.84042 13.3353 5 15.0103 5C15.6664 5 16.197 5.13789 16.5316 5.26277ZM18.7858 9.09749H20.1956C20.1259 8.78889 19.8047 7.31147 19.8047 7.31147L19.6862 6.77964C19.6024 7.00943 19.4559 7.38373 19.463 7.37056C19.463 7.37056 18.9255 8.7429 18.7858 9.09749ZM20.8795 5.11188L22.2478 11.284H20.6774C20.6774 11.284 20.5237 10.5748 20.475 10.3581H18.2973C18.2343 10.5222 17.9414 11.284 17.9414 11.284H16.1617L18.681 5.62399C18.8556 5.22342 19.163 5.11188 19.5675 5.11188H20.8795Z",
				fill: "#171E6C"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_66_2091",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 23.9289,
				height: 16,
				fill: "white",
				transform: "translate(0.312927)"
			})
		}) })
	]
});
export default SvgVisaLogo;
